import { createTheme } from '@mui/material/styles';

// IMO Color Palette from website
const imoColors = {
  black: '#000000',
  teal: '#206884',
  cream: '#FEFDF6',
  skyblue: '#74C0E6',
  brown: '#935325',
  lavender: '#BDB6FD',
  lime: '#6CCC16',
  forest: '#3A8830',
  blue: '#2096F3',
};

const theme = createTheme({
  palette: {
    primary: {
      main: imoColors.teal, // IMO Teal
      light: imoColors.skyblue, // IMO Sky Blue
      dark: '#1a5568',
      contrastText: '#ffffff',
    },
    secondary: {
      main: imoColors.blue, // IMO Blue
      light: '#4da8f5',
      dark: '#1875c4',
      contrastText: '#ffffff',
    },
    success: {
      main: imoColors.lime, // IMO Lime
      light: '#8dd83a',
      dark: imoColors.forest, // IMO Forest
    },
    background: {
      default: imoColors.cream, // IMO Cream
      paper: '#ffffff',
    },
    text: {
      primary: '#111827', // Gray-900
      secondary: '#6b7280', // Gray-500
    },
    grey: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.875rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem',
          textTransform: 'none',
          fontWeight: 600,
          padding: '0.75rem 1.5rem',
        },
        contained: {
          boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
          '&:hover': {
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: imoColors.teal, // IMO Teal #206884
          color: '#ffffff',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;

